import script from "./AdditionalPhotoUploadModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalPhotoUploadModalComponent.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalPhotoUploadModalComponent.vue?vue&type=style&index=0&id=11d1f8b1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d1f8b1"]])

export default __exports__